import React, { useEffect, useState } from "react"
import {
  ClassicEditor,
  SourceEditing,
  Essentials,
  Undo,
  Heading,
  Bold,
  Italic,
  Link,
  List,
  FileRepository,
  Indent,
  Image,
  ImageUpload,
  ImageStyle,
  ImageToolbar,
  LinkImage,
  ImageResize,
  ImageCaption,
  GeneralHtmlSupport,
  Table,
  TableToolbar,
  MediaEmbed,
  MediaEmbedEditing,
  MediaEmbedToolbar,
  Font,
  WordCount,
  Alignment,
} from "ckeditor5"
import { CKEditor } from "@ckeditor/ckeditor5-react"
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CustomUploadAdapterPlugin from "./CustomUploadAdapter"

import "ckeditor5/ckeditor5.css"

const MyEditor = ({
  value = null,
  onChange = () => console.log("onChange!"),
  isError = false,
  disabled = false,
  onReady = () => {},
  id = ''
}) => {
  // border: 1px solid red;
  // border-radius: 4px;
  const [charCount, setCharCount] = useState(0);
  return (
    <div id={id} className={`b-my-editor input-len-box ${isError ? "is-invalid error" : ""}`}>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        config={{
          extraAllowedContent: "*",
          toolbar: {
            items: [
              "undo", "redo",
              "|",
              "sourceEditing",
              "|",
              "heading",
              "|",
              "fontSize", "fontColor", "bold", "italic",
              "|",
              "alignment",
              "|",
              "link", "insertTable",
              '|',
              "uploadImage", 'imageTextAlternative', 'linkImage',
              "|",
              "mediaEmbed",
              "|",
              "bulletedList", "numberedList", "outdent", "indent",
            ],
          },
          plugins: [
            GeneralHtmlSupport,
            SourceEditing,
            Essentials,
            Undo,
            FileRepository,
            Heading,
            Bold,
            Italic,
            Link,
            List,
            Indent,
            Image,
            ImageUpload,
            ImageCaption,
            ImageResize,
            ImageStyle,
            ImageToolbar,
            LinkImage,
            Table,
            TableToolbar,
            MediaEmbed,
            MediaEmbedEditing,
            MediaEmbedToolbar,
            Font,
            WordCount,
            Alignment,
          ],
          extraPlugins: [CustomUploadAdapterPlugin], // เพิ่ม Custom Upload Adapter Plugin
          htmlSupport: {
            allow: [
              {
                name: /^.*$/,
                attributes: true,
                classes: true,
                styles: false
              }
            ]
          },
          mediaEmbed: {

          },
          link: {
            addTargetToExternalLinks: true
          },
          wordCount: {
            onUpdate: stats => {
              setCharCount(stats.characters);
            }
          },
        }}
        onReady={onReady}
        onChange={(event, editor) => {
          onChange(event, editor)
        }}
        disabled={disabled}
      />
      <p className="b-txt-count">{charCount}</p>
    </div>
  )
}

export default MyEditor
